import type { CatalogoDescriptor } from '@next/compartilhados/catalogos'

export type OpcaoLocalDeTrabalho = Readonly<{
  id: string
  name: string
  code?: string | null
  active?: boolean
  visivel?: boolean
  empregadores?: readonly string[]
  priority?: number
  ddd?: string | number | null
  region?: Readonly<{ name?: string | null, parent?: string | null }> | null
  totalOfEmployees?: number
  hasOnCall?: boolean
}>

export type FiltrosCatalogoLocalDeTrabalho = Readonly<{
  id?: readonly string[]
  active?: boolean
  visivel?: boolean
  empregadores?: readonly string[]
}>

export type SelecaoCatalogoLocalDeTrabalho =
  | OpcaoLocalDeTrabalho
  | readonly OpcaoLocalDeTrabalho[]
  | null

export type OperacoesCatalogoLocalDeTrabalho = Readonly<{
  listarOpcoes: (sinal: AbortSignal) => Promise<readonly OpcaoLocalDeTrabalho[]>
}>

export const DESCRITOR_CATALOGO_LOCAL_DE_TRABALHO:
CatalogoDescriptor<OpcaoLocalDeTrabalho> = Object.freeze({
  nome: 'locais-de-trabalho',
  versaoProjecao: 3,
  validarItens: (valor: unknown): valor is readonly OpcaoLocalDeTrabalho[] => (
    Array.isArray(valor) && valor.every(item => (
      typeof item === 'object' && item !== null && !Array.isArray(item)
    ))
  ),
})
